import { Fade, IconButton, useScrollTrigger, Box } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

function ScrollTop(props) {
  const { children } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');
    if (anchor) {
      anchor.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
      >
        <IconButton
          color="primary"
          aria-label="scroll back to top"
          sx={{
            backgroundColor: 'primary.main',
            color: 'white',
            '&:hover': {
              backgroundColor: 'primary.dark',
              transform: 'translateY(-3px)',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            },
            transition: 'all 0.3s ease',
            width: 48,
            height: 48,
          }}
        >
          <KeyboardArrowUp />
        </IconButton>
      </Box>
    </Fade>
  );
}

export default ScrollTop;
